import React from 'react'
import './Friend.css'
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState, useContext } from 'react';
import Topbar from '../../components/topbar/Topbar';
import Bottom from '../../components/Bottom/Bottom';
import axiosInstance from '../../config';
import CloseFriend from '../../components/closeFriend/CloseFriend';
import SocialContext from '../../context/SocialContext';
import Progress from '../../components/Progress/Progress';

export default function FriendsRequest() {
    const navigate = useNavigate();
    const { fetchcurrentuserfun } = useContext(SocialContext);

    const PF = "https://socialshub.netlify.app/images/";
    const [allusers, setallusers] = useState([]);
    const [loading, setloading] = useState(false);

    const fetchallusers = async () => {
        try {
            setloading(true);
            const response = await axiosInstance.get('/api/users/getallusers');
            setallusers(response.data.sort((p1, p2) => {
                p1=p1.username.toLowerCase()
                p2=p2.username.toLowerCase()
                return p1 < p2 ? -1 : p1 > p1 ? 1 : 0;
            }));
            setloading(false);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        fetchallusers();
        if (window.localStorage.getItem('currentUID')) {
            fetchcurrentuserfun();
        } else {
            navigate('/');
        }
        window.document.title='SocialHub - Networks';
    }, [])

    return (
        <>
            <Topbar />

            <div className="friendsContainer">
                <div className="friendRequest">
                    <h2 style={{ 'textAlign': 'center', color: 'blue', 'background': 'white', padding: '5px', 'width': '60%', margin: 'auto', 'borderRadius': '12px' }}>Networks</h2>
                    {loading ? <div style={{ 'minHeight': '100vh', display: 'flex', 'alignItems': 'center', 'justifyContent': 'center' }}><Progress /></div> : ''}
                    {allusers.map((user) => (
                        <CloseFriend key={user._id} user={user} />
                    ))}
                </div>
            </div>
            <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
                <p style={{ 'textAlign': 'center', opacity: '0.6' }}>Copyright ©2022-Alok.info | All rights reserved</p>
            </div>
            <Bottom />
        </>
    )
}